import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {CatalogService} from '../../../Services/CatalogManagement/catalog.service';
import {CustomerStatistics} from 'app/Model/Dto/CustomerStatistics';
import {LoginService} from 'app/Services/login.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
  standalone: false
})
export class DashboardComponent implements OnInit {
  customerStatistics: CustomerStatistics[] = [];

  constructor(
    public loginService: LoginService,
    public catalogService: CatalogService,
    public translate: TranslateService
  ) {}

  async ngOnInit(): Promise<void> {
    const currentCustomerId = this.loginService.currentCustomer?.id;
    if (!currentCustomerId) return;
    this.loadCustomerStatistics(currentCustomerId);
  }

  private loadCustomerStatistics(customerId: string) {
    this.loginService.getCustomerStatistics(customerId).subscribe((stats: CustomerStatistics[]) => {
      this.customerStatistics = (stats ?? []).map((statistic) => new CustomerStatistics().deserialize(statistic));
      this.customerStatistics.forEach((cusotomerStat) => ((cusotomerStat as CustomerStatistics).date = cusotomerStat.date instanceof Date ? cusotomerStat.date : new Date(cusotomerStat.date)));
    });
  }

  customizeTooltip = (info: any) => {
    const argumentValue: any = info.argument;
    const date = argumentValue instanceof Date ? argumentValue.toLocaleDateString() : info.argumentText;
    return { text: `${date}\n${info.seriesName}: ${info.valueText}` };
  };
}
